import { resolveDocumentColorToCss } from ".//theme-color-token.js";
const resolveCssColor = (color) => resolveDocumentColorToCss(color) ?? color;
export {
  resolveCssColor
};
//# sourceMappingURL=resolve-css-color.js.map
